<template lang="pug">
transition-group.root(
  :tag="tag"
  name="shuffle")
  slot
</template>

<script>
export default {
  name: "Shuffle",
  props: ['tag']
};
</script>

<style scoped lang="scss">
.root {
  position: relative;
  
  &::v-deep {
    & > * {
      will-change: height;
      transform: translateZ(0);
      backface-visibility: hidden;
      perspective: 1000px;
      transition: height 350ms ease, opacity 350ms ease;
    }
    
    .shuffle-enter {
      opacity: 0;
      transform: translateY(30px);
    }
    .shuffle-leave-to {
      opacity: 0;
    }
    .shuffle-leave-active {
      position: absolute;
    }
  }
}
</style>
